import { useCallback } from 'react'
import { useFormatMessage } from '@/translations/useFormatMessage'
import { Popover } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@/store'
import { logout } from '@/store/authSlice'
import { oocApi } from '@/lib/apiClient'
import { oocUrls } from '@/lib/urlBuilder'
import { logWarning } from '@/services/errorService'
import {
	StyledPopoverContent,
	StyledEmail,
	StyledDivider,
	StyledLogoutButton,
} from './AccountPopover.styled'
import type { AccountPopoverProps } from './AccountPopover.types'

export function AccountPopover({ isOpen, anchorEl, onClose }: AccountPopoverProps) {
	const dispatch = useAppDispatch()
	const { t } = useFormatMessage()
	const authUser = useAppSelector((state) => state.auth.user)

	const handleLogout = useCallback(() => {
		void (async () => {
			try {
				await oocApi.del(oocUrls.logout())
			} catch (error) {
				logWarning('[AccountPopover] Logout API failed', { error: String(error) })
			} finally {
				dispatch(logout())
				onClose()
			}
		})()
	}, [dispatch, onClose])

	if (!authUser) return null

	return (
		<Popover
			open={isOpen}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
		>
			<StyledPopoverContent>
				<StyledEmail>{authUser.name || authUser.email || authUser.phone}</StyledEmail>
				<StyledDivider />
				<StyledLogoutButton type="button" onClick={handleLogout}>
					{t('signin:accountPopover:logoutButton')}
				</StyledLogoutButton>
			</StyledPopoverContent>
		</Popover>
	)
}
